// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2dhND","errorLogs":"EditorFooter_errorLogs__td8zW"};